import React from 'react';
import { BookingEntity, FreightContactEntity } from 'Models/Entities';
import { whiteLabelStore } from 'Models/WhiteLabelStore';
import { DisplayUnits } from 'Util/UnitOfMeasurementUtils';
import { FormatPhone } from 'Util/StringUtils';
import { CheckInBookingOverviewDto } from '../../CheckInEntities/CheckInBookingOverviewDto';

export function transformFreightCategory(booking: BookingEntity | CheckInBookingOverviewDto) {
	if (!booking || !booking.bookedSummary) return null;
	const { freightDetail } = booking.bookedSummary;
	if (!freightDetail) {
		return null;
	}
	return freightDetail.freightCategory?.label ?? null;
}

export function transformFreightDescription(booking: BookingEntity | CheckInBookingOverviewDto) {
	if (!booking || !booking.bookedSummary) return null;
	const { freightDetail } = booking.bookedSummary;
	if (!freightDetail) {
		return null;
	}
	return freightDetail.description;
}

export function transformFreightQuantity(booking: BookingEntity | CheckInBookingOverviewDto) {
	if (!booking || !booking.bookedSummary) return 1;
	const { freightDetail } = booking.bookedSummary;
	if (!freightDetail) {
		return 1;
	}
	return freightDetail.quantity;
}

export function transformDimension(booking: BookingEntity | CheckInBookingOverviewDto) {
	if (!booking || !booking.bookedSummary) return '-';
	const { freightDetail } = booking.bookedSummary;
	if (!freightDetail) {
		return '-';
	}

	return DisplayUnits.dimensions.format({
		length: freightDetail.length,
		width: freightDetail.width,
		height: freightDetail.height,
		unitOfMeasurement: whiteLabelStore.systemMeasurementUnit,
	});
}
export function transformContactDetails(contactDetails?: FreightContactEntity) {
	if (!contactDetails) {
		return <>-</>;
	}
	return (
		<div className="multi-line-cell">
			<p className="label">
				{contactDetails.firstName ?? ''} {contactDetails.lastName ?? ''}
			</p>
			<p className="description">
				<a
					href={`tel:${FormatPhone(contactDetails.phone)}`}
					className="booking-form__field--value hide-underline"
					onClick={e => e.stopPropagation()}
				>
					{FormatPhone(contactDetails.phone)}
				</a>
			</p>
		</div>
	);
}
